export default __webpack_public_path__ + "static/media/governorvisit.5c3fe0d3.webp";